<template>
  <section class="deals-list">
    <h5>Deal Examples</h5>

    <deal-item
      v-for="deal in deals"
      :key="deal._id"
      :deal="deal"
      :isExample="true"
      class="deal-item"
      @click="$router.push({ name: 'sign-up' })"
    />
  </section>
</template>

<script>
import DealItem from "../deals/deal-item.vue";
import dealsData from "../../data/deals-data";

export default {
  name: "available-tab",
  components: {
    DealItem,
  },
  computed: {
    deals() {
      return dealsData;
    },
  },
};
</script>

<style lang="scss" scoped>
.deals-list {
  color: #fff;
  h5 {
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 50px;
  }
  .deal-item {
    max-width: 840px;
    margin: 10px auto;
  }
}
</style>
